var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "enter_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5,13.8v68.4c0,4.301-3.141,7.8-7,7.8h-54c-3.86,0-7-3.499-7-7.8V57.462h8V82h52V14h-52v24.925h-8V13.8 c0-4.301,3.14-7.8,7-7.8h54C86.359,6,89.5,9.499,89.5,13.8z M57.764,51.98l10.259-0.032c1.648-0.005,3.126-1.021,3.719-2.558 c0.593-1.537,0.185-3.282-1.033-4.395L55.422,31.08c-1.55-1.472-3.596-2.215-5.733-2.117c-2.135,0.095-4.102,1.019-5.539,2.597 l13.59,12.42c-0.003,0.009-56.051,0.183-56.051,0.183l0.024,8C1.713,52.163,57.764,51.988,57.764,51.98z M44.248,64.492 c1.447,1.57,3.419,2.483,5.554,2.565c2.138,0.085,4.177-0.668,5.748-2.121l8.317-7.698l-11.8,0.022L44.248,64.492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.8f6534bbd4357ae2d15c15f5c7fc0ec0.svg";
export { ForwardRef as ReactComponent };